module.exports = __webpack_public_path__ + "static/img/1681_phase_function_Paper_Points.ea5fb0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1681_phase_function_Paper_Points.png
// module id = fC/x
// module chunks = 0